import { registerComponent } from '@gig/magic-common';
import FaqEntriesComponent from './faq-entries.vue.js';

var FaqEntries = registerComponent(FaqEntriesComponent);

export { FaqEntries };
